var map = {
	"./AUNTY.png": 363,
	"./aakash.jpeg": 544,
	"./award.png": 214,
	"./background..jpg": 745,
	"./divu.png": 32,
	"./divya.png": 609,
	"./donate.png": 809,
	"./dummy.jpg": 685,
	"./female.png": 494,
	"./group.png": 531,
	"./group2.png": 174,
	"./keyword.png": 573,
	"./lindsey-lamont-hUWINRMPvsc-unsplash.jpg": 294,
	"./newLifeLogo.png": 751,
	"./power.pg.jpg": 905,
	"./report.png": 575,
	"./silhouette-freedom-girl-birds-198114012.jpg": 121,
	"./wing.png": 38,
	"./wings.jpeg": 984,
	"./wings.png": 958,
	"./wingss.png": 282,
	"./women.jpeg": 939,
	"./womenp.png": 145,
	"./womens.webp": 597,
	"./wonderlane-w1s5H_3Zn48-unsplash.jpg": 701,
	"./work.png": 897,
	"./work2.png": 239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;